import { useEffect, useState } from "react";
import { AiOutlineCar } from "react-icons/ai";
import Count from "../../../components/shared/Count";
import fetchWipBooked from "../../../services/fetchWipBooked";
import BookedPanel from "./BookedPanel";

export default function BookedWidget({ startDate, endDate }: any) {
  const [vehicleBooked, setVehicleBooked] = useState<any>([]);
  const [showDetails, setShowDetails] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const handleFetchVehicleBooked = async () => {
    setLoading(true);
    const response = await fetchWipBooked(startDate, endDate);
    setVehicleBooked(response);
    setLoading(false);
  };

  useEffect(() => {
    handleFetchVehicleBooked();
  }, []);

  return (
    <div className="py-2 px-3 flex flex-row items-center bg-white border border-gray-300 rounded-lg mb-2 hover:bg-red-100 cursor-pointer">
      <button
        className="flex flex-row items-center justify-start"
        onClick={() => setShowDetails(true)}
      >
        <div className="bg-gray-100 h-16 w-16 rounded-full text-white flex justify-center items-center">
          <AiOutlineCar size={35} color="#E50000" />
        </div>
        <div className="flex flex-col ml-2 justify-start items-start">
          <div className="text-xs text-blue-900 font-bold uppercase">
            Vehicles Booked
          </div>
          <div className="text-sm">
            <div className="rounded-sm text-black text-3xl font-bold">
              <Count isLoading={isLoading} count={vehicleBooked?.length} />
            </div>
          </div>
        </div>
      </button>

      <BookedPanel
        isVisible={showDetails}
        setShowDetails={setShowDetails}
        vehicleBooked={vehicleBooked}
        startDate={startDate}
        endDate={endDate}
      />
    </div>
  );
}
